/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/dtw-grand-central.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/dtw-grand-central.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/dtw-grand-central.mdx';

const metadata = {
  slug: "dtw-grand-central",
  title: "DTW: Grand Central",
  author: "Christian Battaglia",
  description: "How we combined React, AngularJS, Redux, and Router5 into a single application with a service registry, dependency injection, and dynamically loaded bundles per route — a pioneering micro-frontend architecture built at Amplify.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/grand-central-nyc.jpg",
  date: "2019-10-28T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["React","AngularJS","Redux","Router5","micro-frontends","dependency injection","webpack","JavaScript","architecture"],
};

export const Route = createFileRoute('/blog/posts/dtw-grand-central')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/dtw-grand-central',
    image: '/og/blog/dtw-grand-central.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
